var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 py-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-32" }, [_vm._v("Deel je teamdag")]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-24" }, [
        _vm._v(
          "\n        Vul e-mailadressen in, kopieer de link, of download een PDF. Kies\n        hoe anderen jouw planning zien: bekijken, bewerken of dupliceren.\n    "
        )
      ]),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "observer",
        attrs: { tag: "div", slim: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              return [
                _c("div", { staticClass: "row mb-40" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 " },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.translations.share_popup.emails))
                      ]),
                      _vm._v(" "),
                      _c("input-tag", {
                        attrs: {
                          "add-tag-on-blur": true,
                          placeholder: _vm.translations.share_popup.emails,
                          validate: "email"
                        },
                        on: { input: _vm.tagsChanged },
                        model: {
                          value: _vm.emails,
                          callback: function($$v) {
                            _vm.emails = $$v
                          },
                          expression: "emails"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "label" }, [
                  _vm._v(
                    "\n            De ontvanger mag je dag samenstelling:\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-toolbar mb-64",
                    attrs: { role: "toolbar" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn-group flex-1",
                        attrs: { role: "group" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn flex-1 btn-accent ",
                            class:
                              _vm.mode === "read"
                                ? "text-white"
                                : "bg-white text-accent",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.setMode("read")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    Bekijken\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn flex-1 btn-accent",
                            class:
                              _vm.mode === "edit"
                                ? "text-white"
                                : "bg-white text-accent",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.setMode("edit")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    Bewerken\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn flex-1 btn-accent",
                            class:
                              _vm.mode === "clone"
                                ? "text-white"
                                : "bg-white text-accent",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.setMode("clone")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    Dupliceren\n                "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mt-24 mt-md-40"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-self-stretch justify-content-between flex-column"
                      },
                      [
                        _c("div", { staticClass: "position-relative d-flex" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:copy",
                                  value: _vm.shareLink,
                                  expression: "shareLink",
                                  arg: "copy"
                                },
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:success",
                                  value: _vm.onCopy,
                                  expression: "onCopy",
                                  arg: "success"
                                }
                              ],
                              staticClass: "export"
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.svg("link", "icon"))
                                }
                              }),
                              _vm._v("Link\n                        kopiëren")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "tooltip tooltip-top",
                              class: { visible: _vm.copied }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.translations.share_popup.copied)
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "export",
                            attrs: {
                              href: _vm.route("schedule-pdf", [
                                _vm.localSchedule.id
                              ]),
                              target: "_blank"
                            }
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.svg("export", "icon"))
                              }
                            }),
                            _vm._v(
                              _vm._s(_vm.translations.save_popup.export_pdf)
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-accent text-white",
                        attrs: {
                          type: "submit",
                          disabled:
                            invalid ||
                            _vm.emails.length === 0 ||
                            _vm.submitted ||
                            !_vm.acceptedPrivacyPolicy
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.submit($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.translations.share_popup.send) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }